

// export const images = [
//     "https://www.nitp.ac.in/static/5aa4774b23d2bd7346e3ffe71030020e/d8255/homebg-3.jpg",
//     "https://www.nitp.ac.in/static/2a7dd36accbfecf8426d6b1b61f5aa95/d8255/sac.jpg",
//     "https://www.nitp.ac.in/static/0012c5fbd49f51f1b4f15694024903ce/d8255/homebg-4.jpg",
//     "https://www.nitp.ac.in/static/b1f57f10369474f4dd4699aa6915b06c/d8255/homebg-5.jpg", 
//     "https://www.nitp.ac.in/static/7e2c6a20b7557a7ece31f76d227fe267/9a128/2021-05-02_1_1920x1080_1_900x500_1_700x500.jpg",
//     "https://www.nitp.ac.in/static/8b5f71c427f19c61c668aee51452e9c3/9a128/2021-09-26_700x500.jpg",
//     "https://www.nitp.ac.in/static/47968ca3832fac800f5afef6951b189e/d8255/IMG_20190502_180621_4_1920x1080.jpg",
//     "https://www.nitp.ac.in/static/445ad95d61b800bd57fc22b8657fdc52/9842e/IMG_20210810_122357__02_1920x1080_2_900x500.jpg",
//     "https://www.nitp.ac.in/static/71ba05250af9dd5de595b3e79fd2f9e7/7f945/thetaplus_20210210081905626-01_1920x1080_1_1440x685.jpg",

// ];





import image1 from "../imagess/image1.jpg";
import image2 from "../imagess/image2.jpg";
import image3 from "../imagess/image3.jpg";
import image4 from "../imagess/image4.jpg";
import image5 from "../imagess/image5.jpg";
import image6 from "../imagess/image6.jpg";
import image7 from "../imagess/image7.jpg";
import image8 from "../imagess/image8.jpg";
import image9 from "../imagess/image9.jpg";
import image10 from "../imagess/image10.jpg";
import image11 from "../imagess/image11.jpg";



export const images = [image1,image2,image3,image4,image5,image6,image7,image8,image9,image10,image11];






